import "regenerator-runtime/runtime";
import axios from "axios";

const UNIQUE_CLIENT_ID_GENERATOR_URL = '/rest/clientidentificator/manage/create';
const UNIQUE_CLIENT_ID = 'uniqueClientId';

export const getClientIdentificator = async () => {
    if (window.localStorage.getItem(UNIQUE_CLIENT_ID) === null) {
        return await obtainNewClientIdentifier();
    }

    return window.localStorage.getItem(UNIQUE_CLIENT_ID);
};
const obtainNewClientIdentifier = () => {
    return axios.get(UNIQUE_CLIENT_ID_GENERATOR_URL)
        .then((response) => {
            window.localStorage.setItem(UNIQUE_CLIENT_ID, response.data.data);

            return response.data.data;
        });
};
